export const toPercent = (score) => {
  return isNaN(score) ? "-" : parseInt((score / 10) * 100);
};

export const getSummaryScore = (scores) => {
  return scores.reduce((total, score) => total + score, 0);
};
